import qs from 'querystring'
 
import _ from 'underscore'
import Api from '../lib/request'
import { itemList } from '../mock/item'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'
import { toLogin } from '../util/function'
import STATUS_CODE from '../constant/status_code'

const getCartTotal = () => {
  return new Promise((resolve, reject) => {
    const url = COOKIECONSTANT.REQUEST_HOST
    Api.get(url, {
      headers: {
        'X-Host': 'mall.cart.total',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}

// const getCartSku = () => {
//   return new Promise((resolve, reject) => {
//     const url = COOKIECONSTANT.REQUEST_HOST
//     Api.get(url, {
//       headers: {
//         'X-Host': 'mall.cart.list',
//         'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
//       }
//     }).then((data) => {
//       if (data.status === 6666) {
//         return toLogin()
//       }
//       if (data.status !== 0) {
//         return reject(data.msg)
//       }
//       resolve(data.data)
//     }, (e) => {
//       reject(e)
//     })
//   })
// }

const getCartSku = (options) => {
  return new Promise((resolve, reject) => {
    const url = COOKIECONSTANT.REQUEST_HOST
    const op = JSON.stringify(options)
    Api.post(url, op, {
      headers: {
        'X-Host': 'mall.cart.cartlist',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then((data) => {
      if (data.status === 6666) {
        return toLogin()
      }
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}

const selectCartSku = (options) => {
  return new Promise((resolve, reject) => {
    const url = COOKIECONSTANT.REQUEST_HOST
    const op = JSON.stringify(options)
    Api.post(url, op, {
      headers: {
        'X-Host': 'mall.cart.select-cart-sku',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then((data) => {
      if (data.status === 6666) {
        return toLogin()
      }
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}

const deleteCartSku = (options) => {
  return new Promise((resolve, reject) => {
    const url = COOKIECONSTANT.REQUEST_HOST
    const op = JSON.stringify(options)
    Api.post(url, op, {
      headers: {
        'X-Host': 'mall.cart.batch-delete',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then((data) => {
      if (data.status === 6666) {
        return toLogin()
      }
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve()
    }, (e) => {
      reject(e)
    })
  })
}

const updateSku = (options) => {
  return new Promise((resolve, reject) => {
    const url = COOKIECONSTANT.REQUEST_HOST
    const op = JSON.stringify(options)
    Api.post(url, op, {
      headers: {
        'X-Host': 'mall.cart.batch-update',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then((data) => {
      if (data.status === 6666) {
        return toLogin()
      }
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve()
    }, (e) => {
      reject(e)
    })
  })
}

const addSku = (options) => {
  return new Promise((resolve, reject) => {
    const url = COOKIECONSTANT.REQUEST_HOST
    const op = JSON.stringify(options)
    Api.post(url, op, {
      headers: {
        'X-Host': 'mall.cart.batch-add',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then((data) => {
      if (data.status === 6666) {
        return toLogin()
      }
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve()
    }, (e) => {
      reject(e)
    })
  })
}

// const getSkuById = (options) => {
//   const query = _.isEmpty(options) ? `` : `?${qs.stringify(options)}`
//   return new Promise((resolve, reject) => {
//     const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
//     Api.get(url, {
//       headers: {
//         'X-Host': 'mall.product.sku-list',
//         'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
//       }
//     }).then((data) => {
//       if (data.status !== 0) {
//         return reject(data.msg)
//       }
//       resolve(data.data)
//     }, (e) => {
//       reject(e)
//     })
//   })
// }

const getSkuById = (options) => {
  return new Promise((resolve, reject) => {
    const url = COOKIECONSTANT.REQUEST_HOST
    const op = JSON.stringify(options)
    Api.post(url, op, {
      headers: {
        'X-Host': 'mall.cart.visitor-cartlist',
      }
    }).then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}

const verifyCart = (options) => {
  return new Promise((resolve, reject) => {
    const url = COOKIECONSTANT.REQUEST_HOST
    const op = JSON.stringify(options)
    Api.post(url, op, {
      headers: {
        'X-Host': 'mall.order.verify.v2',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then((data) => {
      if (data.status === 6666) {
        return toLogin()
      }
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}

const getTyingProductPriceSection = (options) => {
  return new Promise((resolve, reject) => {
    const url = COOKIECONSTANT.REQUEST_HOST
    const op = JSON.stringify(options)
    Api.post(url, op, {
      headers: {
        'X-Host': 'mall.cart.tying-product-price-section',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}

const getTyingProducts = (options) => {
  return new Promise((resolve, reject) => {
    const url = COOKIECONSTANT.REQUEST_HOST
    const op = JSON.stringify(options)
    Api.post(url, op, {
      headers: {
        'X-Host': 'mall.cart.tying-product-list',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then((data) => {
      if (data.status === STATUS_CODE.EMPTY_LIST) {
        return resolve(null)
      }
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}

const getCartExpressFeeTip = (options) => {
  return new Promise((resolve, reject) => {
    const url = COOKIECONSTANT.REQUEST_HOST
    const op = JSON.stringify(options)
    Api.post(url, op, {
      headers: {
        'X-Host': 'mall.cart.express-fee-tip',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    }).then((data) => {
      if (data.status === STATUS_CODE.EMPTY_LIST) {
        return resolve(null)
      }
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}
/*yeoman-template-point-1*/

export default {
  getCartTotal,
  getCartSku,
  deleteCartSku,
  updateSku,
  addSku,
  getSkuById,
  verifyCart,
  selectCartSku,
  getTyingProductPriceSection,
  getTyingProducts,
  getCartExpressFeeTip,
/*yeoman-template-point-2*/
}
